export default "__VITE_ASSET__D4ioZE9g__";